/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Card, Switch, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Loading } from '../../../../helpers/utils';
import NewSemester from './NewSemester';
import SemestersList from './SemestersList';
import companyServices from '../../../../redux/services/companyServices';
import semesterServices from '../../../../redux/services/semesterServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
}));

const Semesters = ({ company, ponderation, updatePonderation }) => {
  const [semestersData, setSemestersData] = useState([]);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const [semestersList, setSemestersList] = useState([]);
  const [catchUpSemesters, setCatchUpSemesters] = useState([]);
  const [referentsList, setReferentsList] = useState([]);
  const classes = useStyles();

  const handleSemestersData = (semesters) => {
    setSemestersData(semesters.sort((a, b) => a.semester > b.semester));
  };

  useEffect(() => {
    setLoading(true);
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        handleSemestersData(res.semesters);
        setType(res.adminData.type);
      });
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setReferentsList(res.pedagogicData);
      });
  }, []);

  useEffect(() => {
    semesterServices.getAllSemesters()
      .then((allSemesters) => {
        const semesterArr = [];
        allSemesters.forEach((sem) => {
          if (sem.schoolTypes.includes(type)) {
            semesterArr.push(sem);
          }
        });
        semesterArr.sort((a, b) => a.value - b.value);
        const _catchUpSemesters = [];
        const resSem = [];
        semesterArr.forEach((sem) => {
          if (sem.catchUp) {
            _catchUpSemesters.push(sem);
          } else {
            resSem.push(sem);
          }
        });
        setCatchUpSemesters(_catchUpSemesters);
        setSemestersList(resSem);
      });
  }, [type]);

  useEffect(() => {
    if (semestersData !== undefined
      && semestersData.length >= 0
      && semestersList !== undefined
      && semestersList.length > 0) {
      setLoading(false);
    }
  }, [semestersData, semestersList, referentsList]);

  const getSemestersHours = (groups, _semesters) => {
    _semesters.forEach((_sem) => {
      for (let i = 0; groups[i]; i += 1) {
        if (groups[i].semester === _sem.semester) {
          // eslint-disable-next-line no-param-reassign
          _sem.elearningHours = groups[i].elearning.elearningDuration;
        }
      }
    });
    return _semesters;
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginBottom: '15px',
        }}
      >
        <Switch
          checked={ponderation}
          label="Pondération"
          name="Pondération"
          onChange={(e) => {
            updatePonderation(e.target.checked);
          }}
        />
        <Typography
          style={{
            marginLeft: '10px',
          }}
        >
          {ponderation ? 'Désactiver' : 'Activer'}
          {' '}
          la pondération des notes (e-learning/examens)
        </Typography>
      </div>
      {loading === false
        ? (
          <Card className={classes.root}>
            <NewSemester
              companyId={company._id}
              semestersData={semestersData}
              setSemestersData={handleSemestersData}
              catchUpSemesters={catchUpSemesters}
              type={type}
              getSemestersHours={getSemestersHours}
              semestersList={semestersList}
              referentsList={referentsList}
            />
            <SemestersList
              companyId={company._id}
              semestersData={semestersData}
              setSemestersData={handleSemestersData}
              type={type}
              semestersArr={semestersList}
              referentsList={referentsList}
            />
          </Card>
        )
        : <Loading />}
    </>
  );
};

Semesters.propTypes = {
  company: PropTypes.object.isRequired,
  ponderation: PropTypes.bool.isRequired,
  updatePonderation: PropTypes.func.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedSemesters = connect(mapState, null)(Semesters);

export default withRouter(connectedSemesters);
